export enum Topics {
  IDN_AUTHENTICATION = 'IDN_AUTHENTICATION'
}